<template>
	<div>
		<el-button @click="open()">打开弹窗</el-button>
		<!-- ?userid=1298a40e-1566-11ee-91d8-005056b86db5&oid=797f7d4d-12bf-11ef-ade9-005056b86db5&org=1973f6c7-1561-11ee-91d8-005056b86db5 -->
		<!-- ?userid=5943e08c-b7d4-11ed-8d51-005056b86db5&oid=414f2361-ad04-11ed-b13d-005056b86db5&org=0fec3a8a-ad04-11ed-b13d-005056b86db5&role=0 -->
		<!-- <el-button type="primary" @click="$router.push('/classroomObservation?userid=5943e08c-b7d4-11ed-8d51-005056b86db5&oid=414f2361-ad04-11ed-b13d-005056b86db5&org=0fec3a8a-ad04-11ed-b13d-005056b86db5')">去课堂观察</el-button> -->
		<!-- <el-button type="primary" @click="$router.push('/classroomObservation?userid=1298a40e-1566-11ee-91d8-005056b86db5&oid=797f7d4d-12bf-11ef-ade9-005056b86db5&org=1973f6c7-1561-11ee-91d8-005056b86db5')">去课堂观察</el-button> -->
		<el-button type="primary" @click="$router.push('/classroomObservation?userid=6c56ec0e-2c74-11ef-bee5-005056b86db5&oid=414f2361-ad04-11ed-b13d-005056b86db5&org=0fec3a8a-ad04-11ed-b13d-005056b86db5')">去课堂观察</el-button>
		<!-- <el-button type="primary" @click="$router.push('/pblCourse?courseId=75a6969d-f917-11ed-91d8-005056b86db5&userid=cf9fa855-db6b-11ee-b534-005056b86db5&oid=c32d9cc0-db6b-11ee-b534-005056b86db5&org=0fec3a8a-ad04-11ed-b13d-005056b86db5&cid=&tType=1&screenType=1&tcid=fc230009-b963-11ed-8d51-005056b86db5')">去pblCourse</el-button> -->
		<el-button type="primary" @click="$router.push('/guide?userid=6c56ec0e-2c74-11ef-bee5-005056b86db5&oid=c32d9cc0-db6b-11ee-b534-005056b86db5&org=0fec3a8a-ad04-11ed-b13d-005056b86db5')">去课堂列表</el-button>
		<el-button type="primary" @click="$router.push('/contrastObservation?tid=QGT2004022621')">去对比观察</el-button>
		<el-button @click="testUpload">测试上传文件</el-button>

		<shareDialog ref="shareDialogRef"/>
		<uploadFile ref="uploadFileRef"/>
	</div>
</template>

<script>
import shareDialog from './component/shareDialog'
import uploadFile from './component/uploadFile.vue';
export default {
	components:{
		shareDialog,
		uploadFile
	},
	data(){
		return{
			value:``
		}
	},
	methods:{
		open(){
			this.$refs.shareDialogRef.open("cb0d7605-f61d-11ee-b534-005056b86db5");
		},
		testUpload(){
			let input = document.createElement("input");
			input.type = "file";
			// input.accept = ".wav";
			// input.accept = "audio/*, .txt, .pdf, .xlsx";
			input.accept = "*";
			input.click();
			input.onchange = () => {
				this.uploadFileLoading = true;
				let file = input.files[0];
				this.$refs.uploadFileRef.awsupload(file);
			}
		}
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/csTest/index.vue